jQuery(document).ready(function($) {

	$('[name="add-to-cart"], .single_add_to_cart_button').addClass('dom-ready');

	$('.product__read-more').on('click', function() {
		$(this).css('display', 'none');
		$('.product__short-extended').css('display', 'inline');
	});

	$('.product__read-less').on('click', function() {
		$('.product__read-more').css('display', 'inline-flex');
		$('.product__short-extended').css('display', 'none');
	});

	let thumbWidth = 100;
	let thumbMargin = 0;

	if ($(window).width() < 768) {
		thumbWidth = 60;
		thumbMargin = 0;
	}

	if ($('body.single-product').length > 0) {
		$('.product__thumbs').flexslider({
			animation: "slide",
			controlNav: false,
			animationLoop: false,
			slideshow: false,
			itemWidth: thumbWidth,
			itemMargin: thumbMargin,
			asNavFor: '.product__gallery-slider',
			direction: 'vertical'
		});

		$('.product__gallery-slider').flexslider({
			animation: "slide",
			controlNav: false,
			directionNav: false,
			animationLoop: false,
			slideshow: false,
			smoothHeight: true,
			sync: '#product__thumbs',
			start: function(slider){
				$('.product__gallery').addClass('product__gallery--loaded');
			},
			before: function(slider){
				$(slider.newSlides).each(function() {
					if ($(this).find('video').length !== 0) {
						$(this).find('video')[0].pause();
					}
				});
			},
			after: function(slider){
				// Video has to be muted for iOs to except .play, after .play we unmute
				let currentSlide = slider.currentSlide;
				let currentSlideEl = slider.newSlides[currentSlide];
				if ($(currentSlideEl).find('video').length !== 0) {
					if ($(window).width() < 768) {
						$(currentSlideEl).find('.video-click').click();
						// $(currentSlideEl).find('video')[0].webkitEnterFullscreen();
						// $(currentSlideEl).find('video')[0].enterFullscreen();
					} else {
						$(currentSlideEl).find('video')[0].play();
						$(currentSlideEl).find('video')[0]['muted'] = false;
					}
				}
			}
		});
	}

	$('.video-click').on('click', function(e) {
		let vidEl = $(this).parent().find('video');
		vidEl[0].play().catch(console.error);
	})

	if ($(window).width() > 768) {
		$('.product__image video').each(function() {
			$(this).prop('muted', false);
		});
	}

	$('a.product__image-fancy').fancybox({
		'transitionIn'  : 'fade',
		'transitionOut' : 'fade',
		'speedIn'       : 400,
		'speedOut'      : 200,
		'overlayShow'   : false
	});

	$('.product__image--has-video').on('click', function(e) {
		e.preventDefault();
	})

	if ($(window).width() < 641) {
		$('.product__image--has-video').each(function() {
			$(this).removeAttr('data-fancybox');
		});
	}

	let addText = $('.product__add-to-favourites').data('add');
	let removeText = $('.product__add-to-favourites').data('remove');

	if ($('.product__add-to-favourites').hasClass('product__add-to-favourites--added')) {
		$('.product__add-to-favourites').find('span').text(removeText);
	}

	$('.product__add-to-favourites').on('click', function() {
		if ($(this).hasClass('product__add-to-favourites--added')) {
			$(this).removeClass('product__add-to-favourites--added');
			$(this).find('span').text(addText);
		} else {
			$(this).addClass('product__add-to-favourites--added');
			$(this).find('span').text(removeText);
		}
	});

	$('.product__tab-title-container').on('click', function() {
		$(this).toggleClass('product__tab-title-container--open');
		$(this).parent().find('.product__tab-content').slideToggle();
	});

	// Product addon-group toggle
	$('.product__addon-group-header').on('click', function() {
		$(this).parent().toggleClass('product__addon-group--open');
	});


	// Show add-on labels
	$('.wc-pao-addon-image-swatch').each(function() {
		let addon_label = null;
		addon_label = $(this).data('price');
		if (addon_label) {
			$(this).append(addon_label);
		}
	});

	$('.product__addon-info-button').on('click', function() {
		let outer = $(this).parent().parent();
		let desc = $(outer).find('.wc-pao-addon-description');
		if (outer.length > 0) {
			let desc_html = $(desc).html();
			$('.product__addon-desc-inner').html(desc_html);

			// Show side container
			$('.product__addon-desc').addClass('product__addon-desc--open');
		}
	});

	$('.product__addon-close').on('click', function() {
		$('.product__addon-desc').removeClass('product__addon-desc--open');
	});

	$('.editor [data-toggle="collapse"]').on('click', function() {
		$(this).parent().next().css('overflow', 'visible').css('height', 'auto');
	});

	preselectSingleOptions();

	function preselectSingleOptions() {
		if ($('.wc-pao-addons-container').length != 0) {
			$('.product__addon-group').each(function() {

				// Check if group has a required div
				let required = $(this).find('.wc-pao-required-addon');
				if (required.length == 1) {
					let select = $(this).find('select');
					if ($(select).length == 1) {
						let options = $(this).find('select option')
						let optionCount = $(this).find('select option').length;
						// if optionCount == 2 means there is only 1 option, which can be selected by default
						if (optionCount == 2) {
							$(this).find('.wc-pao-addon-image-swatch').addClass('selected');
							// Select correct option in select
							$(options).each(function() {
								if ($(this).val().length > 0) {
									$(this).attr('selected', 'selected');
								}
							})
						}
					}
				}

			})
		}
	}

	// Hide 'Inclusief', 'Inclusive', 'Inklusive' from selected options
	function hideInclusive() {
		let toCheckFor = ['inclusief', 'Inclusief', 'inclusive', 'Inclusive', 'inklusive', 'Inklusive', 'Included', 'included', 'Including', 'including', 'Inklusieve', 'inklusieve'];
		let toCheckForLieferung = ['Lieferung', 'lieferung'];
		$('.product-addon-totals ul li').each(function() {
			let addonText = $(this).find('.wc-pao-col1').text();
			if (addonText.length > 1) {
				if (toCheckFor.some(term => addonText.includes(term))) {
					$(this).hide();
				}
				if (toCheckForLieferung.some(term => addonText.includes(term))) {
					$(this).find('.wc-pao-col2').addClass('wc-pao-col2--show');
				}
			}

		});
	}

	$('.wc-pao-addon-image-swatch').on('click touchstart', function() {
		$('#product-addons-total').addClass('product-addons-total--loading');
		setTimeout(function() {
			hideInclusive();
			$('#product-addons-total').removeClass('product-addons-total--loading');
		}, 300);
	})

	// Custom validation for product addons, preventing to submit when nog all required fields are set.
	$('.single_add_to_cart_button').on('click touchstart', function(e) {
		productAddOnsValidation(e);
		hideInclusive();
	});

	function productAddOnsValidation(e) {
		let validated = false;
		let allSelectValues = [];

		let errorMessage = 'Maak uw keuze';
		let overallErrorMessage = 'Niet alle verplichte velden zijn ingevuld, controleer de bovenstaande velden.'
		if ($('body.wpml-de').length) {
			errorMessage = 'Wählen Sie bitte eine Option';
			overallErrorMessage = 'Es gab ein Problem mit deiner Eingabe. Bitte prüfe die Felder oben.'
		} else if ($('body.wpml-en').length) {
			errorMessage = 'Please select an option';
			overallErrorMessage = 'There was a problem with your submission. Please review the fields above.'
		}

		let errorEl = '<div class="product__addon-error-message">' + errorMessage + '</div>';

		if ($('.wc-pao-addons-container').length != 0) {
			$('.product__addon-group').each(function() {

				// Check if group has a required div
				let required = $(this).find('.wc-pao-required-addon');
				if (required.length == 1) {
					let selectVal = $(this).find('select').val();
					allSelectValues.push(selectVal);
					if (selectVal == '') {
						$(this).addClass('product__addon-group--open product__addon-group--error');
						$(this).find('.product__addon-group-header').append(errorEl);
					} else {
						$(this).removeClass('product__addon-group--error');
						$(this).find('.product__addon-error-message').remove();
					}
				}
			});
		}


		let validatedTestState = NoneEmpty(allSelectValues);
		validated = validatedTestState;

		let overallErrorEl = '<div class="product__addon-overall-error">' + overallErrorMessage + '</div>';

		// validated has to be true to continue order
		if (validated == false) {
			e.preventDefault();
			if ($('form.cart .product__addon-overall-error').length == 0) {
				$('form.cart').append(overallErrorEl);
			}
		} else {
			return;
		}
	}

	function NoneEmpty(arr) {
		for(var i=0; i<arr.length; i++) {
			if(arr[i] === "") return false;
		}
		return true;
	}

    // let wcBreadcrumbAnchors = $('.woocommerce-breadcrumb a');
    //
    // $(wcBreadcrumbAnchors).each(function() {
    //     if ($(this).text() == 'Home') {
    //         $(this).addClass('woocommerce-breadcrumb__home');
    //     }
    // });
    //
    // $('.woocommerce-breadcrumb').css('display', 'flex');

});
